<app-header></app-header>

<div class="content">
  <div class="container">
    <router-outlet></router-outlet>
    <router-outlet name="sidebar"></router-outlet>

    <!-- <app-show-only-for-capgemini-users>
      <app-suggestions-floating-action-button></app-suggestions-floating-action-button>
    </app-show-only-for-capgemini-users> -->

    <app-dialog-host></app-dialog-host>
  </div>
</div>

<app-footer></app-footer>
